module.exports = __webpack_public_path__ + "static/media/dot-theme.05643e4c.svg";